import "rxjs/add/operator/map";

import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MdDialog } from '@angular/material';
import { MdPaginator, MdSort } from "@angular/material";
import { Router } from "@angular/router";

import { AppGlobals } from "./../../Common/Services/app.global";
import { AppUrl } from "./../../Common/appUrl";
import { DialogExamDetailsComponent } from "./../dialog-exam-details/dialog-exam-details.component";
import { Enum } from "../../utility/enum.enum";
import { IesHttpClient } from "../../Common/ies-http-client.service";
import { SharedService } from "./../../Common/Services/shared.service";
import { TableDataSource } from "./../../Common/md-table";
import { Utility } from "./../../Common/Services/utility";
import { userRole_globalAdmin, userRole_regionalAdmin, userRole_siteAdmin, userRole_proctor, userRole_candidate , examTypeOptions} from "./../../Common/appConstant";
import { FeatureFlagService, ToggleName } from "app/Common/Services/feature-flag.service";

@Component({
  selector: "app-adm-manage-eligibilities",
  templateUrl: "./adm-manage-eligibilities.component.html",
  styleUrls: ["./adm-manage-eligibilities.component.css"],
  providers: [FeatureFlagService]
})
export class AdmManageEligibilitiesComponent implements OnInit, OnDestroy {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;

  // used in html to pass url/searchParams to update pagination
  appUrl = AppUrl;
  httpClient: IesHttpClient; // used to make object of md-table
  Enum: any;
  dataSource: TableDataSource | null;
  form: FormGroup;
  regionFilteredOptions: any;
  timeZoneFilteredOptions: any;
  examTypeFilteredOptions: any;
  locationFilteredOptions: any;
  // change these if changing the options below
  statusScheduledIndex: any = 0;
  statusCompletedIndex: any = 1;
  nameOptions: any = [];
  statusOptions: any = [
    {"examStatusCode": "SCHEDULED", "examStatus": "Scheduled"},
    {"examStatusCode": "COMPLETED", "examStatus": "Completed / No Show"},
    {"examStatusCode": "EXAMSTOSCHEDULE", "examStatus": "Unscheduled"},
    {"examStatusCode": "EXAMSEXPIRED", "examStatus": "Expired"}
  ];
  minDate: any;
  maxDate: any;
  isSearchDisabled: boolean;
  isRegionalAdmin: boolean;
  isGlobalAdmin: boolean;
  isSiteAdmin: boolean;
  isProctor: boolean;
  isProctorLead: boolean;
  showScheduleSearch: boolean = true;
  showExamTypeSearch: boolean = true;

  paginationInfo: any;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  displayedColumns = ["candidateName", "userRhId", "candidateEmail", "candidateContactNumber", "examCodeName", "eligibilityCode", "locationName", "examStartDateTime", "statusDisplay"];

  private redirect(): void {
    window.location.assign("/ies/internal/exam-deliveries");
  }

  constructor(private featureFlags: FeatureFlagService, private _sharedService: SharedService, private _router: Router, public _utility: Utility, public _appGlobal: AppGlobals, httpClient: IesHttpClient, public _dialog: MdDialog) {

    // when viwing this page reset candidate status
    this._utility.adminUnbecomeCandidate();

    this.httpClient = httpClient;
    this.Enum = Enum;
    this.form = new FormGroup(
      {
        searchTimeZoneControl: new FormControl(""),
        searchRegionControl: new FormControl(""),
        searchLocationControl: new FormControl(""),
        searchStatusControl: new FormControl(""),
        searchExamTypeControl: new FormControl(""),
        searchEligibilityCodeControl: new FormControl(""),
        searchUserRhIdControl: new FormControl(""),
        searchNameControl: new FormControl(),
        searchUserEmailControl: new FormControl(""),
        searchToDateControl: new FormControl(new Date()),
        searchFromDateControl: new FormControl(new Date())
      }
    )

    this.isSearchDisabled = false;
    this.paginationInfo = { totalRecords: -1 }; // Set initial value of Totalrecords property
    this.checkPermission();
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_EXAM_DELIVERIES_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_EXAM_DELIVERIES_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort, this.httpClient);

    this.form.controls.searchNameControl.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.nameChanges(value);
      });

    this._utility.setDataInComboField("examType", examTypeOptions, this.form.controls.searchExamTypeControl, this);

    // get timeZone data and bind with AutoComplete
    if (this._sharedService.timeZoneList) {
      this._utility.setDataInComboField("timeZone", null, this.form.controls.searchTimeZoneControl, this);
    } else {
      this._utility.addLoaderCount();
      this._sharedService.getComboFieldsData(Enum.TimeZone, (response) => {
        this._utility.removeLoaderCount();
        this._sharedService.timeZoneList = response.response;
        this._utility.setDataInComboField("timeZone", null, this.form.controls.searchTimeZoneControl, this);
      });
    }

    // get region data and bind with AutoComplete
    if (this._sharedService.regionList) {
      this._utility.setDataInComboField("region", null, this.form.controls.searchRegionControl, this);
    } else {
      this._utility.addLoaderCount();
      this._sharedService.getComboFieldsData(Enum.Region, (response) => {
        this._utility.removeLoaderCount();
        this._sharedService.regionList = response.response;
        this._utility.setDataInComboField("region", null, this.form.controls.searchRegionControl, this);
      });
    }

    // get location data and bind with AutoComplete
    if (this._sharedService.locationList) {
      this._utility.setDataInComboField("location", null, this.form.controls.searchLocationControl, this);
      // Set value in field if there are single value
      if (this._sharedService.locationList.length == 1) {
        this.form.controls.searchLocationControl.setValue(this._sharedService.locationList[0]);
      }
    } else {
      this._utility.addLoaderCount();
      this._sharedService.getComboFieldsData(Enum.LocationName, (response) => {
        this._utility.removeLoaderCount();
        this._sharedService.locationList = response.response;
        this._utility.setDataInComboField("location", null, this.form.controls.searchLocationControl, this);
        if (this._sharedService.locationList.length == 1) {
          this.form.controls.searchLocationControl.setValue(this._sharedService.locationList[0]);
        }
      });
    }

    this.form.valueChanges
      .debounceTime(300)
      .distinctUntilChanged()
      .subscribe(form => {
        this.isSearchDisabled = this._utility.searchDisable(form, [
          "searchFromDateControl", "searchToDateControl", "searchStatusControl", "searchExamTypeControl", "searchEligibilityCodeControl",
          "searchUserRhIdControl", "searchUserEmailControl", "searchTimeZoneControl", "searchNameControl",
        ], false);
      });

    this.form.controls.searchFromDateControl.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .subscribe(value => {
        this.fromDateChanges(value);
      });

    this.form.controls.searchToDateControl.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .subscribe(value => {
        this.toDateChanges(value);
      });

    this.form.controls.searchRegionControl.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .subscribe(value => {
        this.regionChanges(value);
      });
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  /**
   * Check User Role
   * Load grid columns and search field as per User role
   */
  checkPermission() {
    let userInfo = this._appGlobal.userInfo.getValue();
    let role = userInfo.userRole;
    role = role && role.toUpperCase();

    this.isGlobalAdmin = false;
    this.isRegionalAdmin = false;
    this.isSiteAdmin = false;
    this.isProctor = false;
    this.isProctorLead = false;
    this.form.controls.searchStatusControl.setValue(this.statusOptions[this.statusScheduledIndex]);

    if (role == userRole_globalAdmin) {
      this.isGlobalAdmin = true;
      this.displayedColumns.push("actions");
      this.statusOptions.push({"examStatusCode": "ERROR", "examStatus": "Error"});
      this.onSearch();
    } else if (role == userRole_siteAdmin) {
      this.isSiteAdmin = true;
      this.form.controls.searchLocationControl.setValidators(Validators.required); // Location is required for Site admin role
      this.statusOptions = [
        {"examStatusCode": "SCHEDULED", "examStatus": "Scheduled"},
        {"examStatusCode": "COMPLETED", "examStatus": "Completed"},
      ];
      this.form.controls.searchStatusControl.setValue(this.statusOptions[this.statusScheduledIndex]);
    } else if (role == userRole_regionalAdmin) {
      this.isRegionalAdmin = true;
      this.displayedColumns.push("actions");
      this.onSearch();
    } else if (role == userRole_proctor) {
      this.isProctor = true;
      this.isProctorLead = userInfo.isProctorLead;
      this.displayedColumns.push("actions");
      this.statusOptions.push({"examStatusCode": "ERROR", "examStatus": "Error"});
      this.form.controls.searchStatusControl.setValue(this.statusOptions[this.statusCompletedIndex]);
      this.onSearch();
    }
  }

  validateDate() {
    let fromDate = this.form.controls.searchFromDateControl;
    let toDate = this.form.controls.searchToDateControl;

    if (fromDate.value && toDate.value) {
      if ((this._utility.convertToDateStr(fromDate.value, "d") > this._utility.convertToDateStr(toDate.value, "d"))) {
        toDate.setErrors({ invalid: true });
      } else {
        toDate.setErrors(null);
      }
    } else {
      if ((toDate.errors && toDate.errors.mdDatepickerParse) || (fromDate.errors && fromDate.errors.mdDatepickerParse)) {
        toDate.setErrors({ mdDatepickerParse: true });
      } else if (toDate.invalid) {
        toDate.setErrors(null);
      }
    }
  }

  fromDateChanges(value: any): void {
    value ? this.minDate = new Date(value) //  Set Min date in ToDate field
    : this.minDate = new Date();
    this.validateDate();
  }

  toDateChanges(value: any): void {
    value ? this.maxDate = new Date(value)
    : this.maxDate = "";
    this.validateDate();
  }

  regionChanges(value: any): void {
    // If there is no any value in region field - display all locations
    if (!value) {
      this._utility.setDataInComboField("location", null, this.form.controls.searchLocationControl, this);
      return;
    }
    if (value && value.id) {
      // Here we have to show locations based on selected region
      let param = "?outputType=" + Enum.LocationName + "&id=" + value.id + "&inputType=" + Enum.Region;
      this._sharedService.requestDataForCombo(param).subscribe(response => {
        this._utility.onSuccessCallback(response, null, () => {
          this._utility.setDataInComboField("location", response.response.results, this.form.controls.searchLocationControl, this);
        });
      });

    } else {
      this.locationFilteredOptions = null;
    }
    this.form.controls.searchLocationControl.setValue("");
  }

  examStatusChanged(val){
    if(val == "EXAMSEXPIRED") {
      this.showScheduleSearch = false;
      this.showExamTypeSearch = false;
    } else if(val == "EXAMSTOSCHEDULE"){
      this.showScheduleSearch = false;
      this.showExamTypeSearch = true;
    } else {
      this.showScheduleSearch = true;
      this.showExamTypeSearch = true;
    }
  }

  getParams() {
    let params = "?"; // add pageNumber & pageSize as required in api
    let formValues = this.form.getRawValue();

    if (formValues.searchRegionControl) {
      params += "regionId=" + formValues.searchRegionControl.id + "&";
    }
    if (formValues.searchLocationControl) {
      params += "locationId=" + formValues.searchLocationControl.id + "&";
    }
    if (formValues.searchStatusControl) {
      params += "status=" + formValues.searchStatusControl.examStatusCode.toUpperCase() + "&";
    }
    if (this.showExamTypeSearch && formValues.searchExamTypeControl && formValues.searchExamTypeControl.examType) {
      params += "examType=" + formValues.searchExamTypeControl.examType + "&";
    }
    if (formValues.searchEligibilityCodeControl) {
      params += "eligibilityCode=" + formValues.searchEligibilityCodeControl.trim() + "&";
    }
    if (formValues.searchUserRhIdControl) {
      params += "userRhId=" + formValues.searchUserRhIdControl.trim() + "&";
    }
    if (formValues.searchUserEmailControl) {
      params += "userEmail=" + formValues.searchUserEmailControl.trim() + "&";
    }
    if (formValues.searchNameControl) {
      params += "userName=" + formValues.searchNameControl.trim() + "&";
    }
    if (formValues.searchFromDateControl) {
      params += "fromDate=" + this._utility.convertToDateStr(formValues.searchFromDateControl, "d") + "&";
    }
    if (formValues.searchToDateControl) {
      params += "toDate=" + this._utility.convertToDateStr(formValues.searchToDateControl, "d") + "&";
    }
    if (formValues.searchTimeZoneControl) {
      params += "timeZone=" + formValues.searchTimeZoneControl.name + "&";
    }
    return params.substring(0, params.length - 1); // remove trailing &
  }

  nameChanges(searchInput: string): void {
    let distinctName = [];

    if (searchInput && searchInput.length > 2) {
      this._sharedService.getUsers("?userRole=" + userRole_candidate + "&searchText=" + searchInput)
        .subscribe(
          response => {
            this._utility.onSuccessCallback(response, null, () => {
              let userList = response.response.results;
              if (userList.length > 0) {
                this.nameOptions = this._utility.checkDuplicateRecord(userList);
              }
            });
          }, error => {
            this._utility.onErrorCallback(error);
          });
    }
  }

  onSearch() {
    this._utility.addLoaderCount();
    this._sharedService.getEligibilities(this.getParams()).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        //initialize index of grid pagination after every search
        this.paginator.pageIndex = 0;
        this.dataSource.curPage = 2;
        this.dataSubject.next(response.response.results);
        if (response.response.paginationInfo) { this.paginationInfo = response.response.paginationInfo; }// update paginaton info
      })
    }, error => this._utility.onErrorCallback(error));
  }

  downloadCsv() {
    this._utility.addLoaderCount();
    this._sharedService.downloadEligibilitiesCsv(this.getParams())
      .subscribe(
        response => {
          this._utility.removeLoaderCount();
          let formValues = this.form.getRawValue();
          let fromDate = this._utility.convertToDateStr(formValues.searchFromDateControl, "d")
          let toDate = this._utility.convertToDateStr(formValues.searchToDateControl, "d");
          let name = formValues.searchStatusControl.examStatus + "Exams";
          if (fromDate) name += "-from-" + fromDate;
          if (toDate) name += "-to-" + toDate;
          this._utility.downloadFileFromBlob(response, name + ".csv");
        });
  }

  downloadProctorCsv() {
    this._utility.addLoaderCount();
    this._sharedService.downloadEligibilitiesForProctorSchedulingCsv(this.getParams())
      .subscribe(
        response => {
          this._utility.removeLoaderCount();
          let formValues = this.form.getRawValue();
          let fromDate = this._utility.convertToDateStr(formValues.searchFromDateControl, "d")
          let toDate = this._utility.convertToDateStr(formValues.searchToDateControl, "d");
          let name = formValues.searchStatusControl.examStatus + "ExamsForProctorScheduling";
          if (fromDate) name += "-from-" + fromDate;
          if (toDate) name += "-to-" + toDate;
          this._utility.downloadFileFromBlob(response, name + ".csv");
        });
  }

  openExamDetailsDialog(eligibilityCode: any, candidateEmail?: any) {
      let params = "?eligibilityCode=" + eligibilityCode+'&useLocationTimeZone=true';
      if (candidateEmail) params += "&candidateEmailForExamOptions=" + candidateEmail;

      this._utility.addLoaderCount();
      this._sharedService.getEligibilities(params).subscribe(data => {
        this._utility.onSuccessCallback(data, null, () => {
          if (data && data.response && data.response.results && data.response.results.length > 0) {
            this._dialog.open(DialogExamDetailsComponent, {
              data: {
                selectedExamFilterType: null,
                userInfo: {},
                examsList: [],
                showCalendar: false,
                examsListFDate: new Date(new Date().getFullYear(), 0, 1),
                examsListTDate: new Date(),
                selectedExamsListType: null,
                selectedExamModel: data.response.results[0],
                idStatusShow: false,
                countryList: [],
                selectedCountry: {}
              }
            });
          }
        });
      }, error => { this._utility.onErrorCallback(error); });

  }

  canShowManage(el: any) {
      return (
        ((el.status == 'SCHEDULED' || el.status == 'RESCHEDULED' || el.status == 'EXAMSTOSCHEDULE') && (this.isGlobalAdmin || this.isRegionalAdmin))
        || ((el.status == 'SITEERROR' || el.status == 'NETWORKERROR') && this.isGlobalAdmin));
  }

  onManageClick(el: any) {
    if ((el.status == "SCHEDULED" || el.status == "RESCHEDULED" || el.status == "EXAMSTOSCHEDULE") && (this.isGlobalAdmin || this.isRegionalAdmin)) {
      this._utility.adminBecomeCandidate(el.userId, el.candidateEmail);
      if (this.isRegionalAdmin) {
        this.openExamDetailsDialog(el.eligibilityCode, el.candidateEmail);
      } else {
        this.openExamDetailsDialog(el.eligibilityCode);
      }
    } else if ((el.status == "SITEERROR" || el.status == "NETWORKERROR") && this.isGlobalAdmin) {
      this._appGlobal.routeWithID = true;
      this._router.navigate(["/AdmManageErrorCase", el.eligibilityCode]);
    }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-eligibilities/adm-manage-eligibilities.component.ts